import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
// import { increment, decrement } from '../redux/counterSlice';
import { Link } from 'react-router-dom';
import { config } from '../utils/config';
import DashboardMap from '../components/DashboardMap';
import Map from '../components/Map';
import State from '../components/State';
import CardContainer from '../components/CardContainer';
import RainfallChart from '../components/DashboardCharts/RA';
import ALC from '../components/DashboardCharts/ALC';
import LS from '../components/DashboardCharts/LS';
import OW from '../components/DashboardCharts/OW';
import TI from '../components/DashboardCharts/TI';
import Mark1 from '@/assets/custom-icon.png';
import map from '@/assets/taipei-zoo-v2.jpg';
import ZoomableImage from '../components/ZoomableImage';
import './Dashboard.css';

function Dashboard() {
    const { slopeData, alertData, devicesInfo } = useOutletContext();
    const forceData = slopeData?.force || [];
    const waterLevelData = slopeData?.water_level || [];
    const tiltData = slopeData?.tilt || [];
    const devicesInfoData = devicesInfo || [];
    const alertStatusData = alertData || [];

    return (
        <div className="dashboard-container">
            <div className="dashboard-state">
                <State />
            </div>
            <div className="dashboard-content">
                <div className="dashboard-map">
                    <DashboardMap />
                </div>
                {/* <div className="charts-container">
                    <CardContainer title="即時雨量監測" color="#54A1C0">
                        <RainfallChart />
                    </CardContainer>
                </div> */}
                {forceData.length > 0 && (
                    <div className="charts-container">
                        <CardContainer title="即時地錨荷重監測" color="#E4B534">
                            <ALC data={forceData} />
                        </CardContainer>
                    </div>
                )}

                {/* <div className="charts-container">
                    <CardContainer title="即時坍方偵測器監測" color="#86A85F">
                        <LS />
                    </CardContainer>
                </div> */}
                {waterLevelData.length > 0 && (
                    <div className="charts-container">
                        <CardContainer title="即時水位觀測井監測" color="#DD5D51">
                            <OW water_level={waterLevelData} />
                        </CardContainer>
                    </div>
                )}
                {tiltData.length > 0 && (
                    <div className="charts-container">
                        <CardContainer title="即時傾斜計監測" color="#9E9D9D">
                            <TI tilt={tiltData} />
                        </CardContainer>
                    </div>
                )}
            </div>
        </div>
    );
}
export default Dashboard;
